import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

// Used to persist the store when the user manually changes the url
const vuexLocalStorage = new VuexPersist({
  storage: window.localStorage,
})

const store = new Vuex.Store({
  state: {
    user: {
      decodedJwtToken: null,
      jwtToken: null,
      roles: null,
      justLoggedIn: true,
      runningTimeout: null,
    }
  },
  getters: {
    getUser: state => state.user,
  },
  mutations: {
    setUser(state, receivedToken) {
      Vue.set(state.user, 'decodedJwtToken', receivedToken.decoded);
      Vue.set(state.user, 'jwtToken', receivedToken.jwtToken);
      Vue.set(state.user, 'roles', receivedToken.roles);
      Vue.set(state.user, 'runningTimeout', receivedToken.runningTimeout);
      if (receivedToken.decoded && receivedToken.jwtToken) {
        Vue.set(state.user, 'justLoggedIn', true);
      } else {
        Vue.set(state.user, 'justLoggedIn', false);
      }
    },
    setJustLoggedIn(state, isJustLoggedIn) {
      Vue.set(state.user, 'justLoggedIn', isJustLoggedIn);
    }
  },
  plugins: [vuexLocalStorage.plugin]
})

export default store


// WEBPACK FOOTER //
// ./src/store.js